import axios from "axios";

export const imageUploader = async (url: string, bufferString: string) => {
  const response = await axios.post(url, { file: bufferString }, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
}